export enum MessageType {
  CHAT = 'CHAT',
  JOIN = 'JOIN',
  LEAVE = 'LEAVE',
  FORBIDDEN = 'FORBIDDEN',
  TRANSFER = 'TRANSFER',
  TRANSFER_COMMENT = 'TRANSFER_COMMENT',
  CONFERENCE = 'CONFERENCE',
  DISCONNECT = 'DISCONNECT',
  END_CONFERENCE = 'END_CONFERENCE',
  FILE = 'FILE',
  DEMAND_SCREEN_SHARING = 'DEMAND_SCREEN_SHARING',
  ACCEPT_SCREEN_SHARING = 'ACCEPT_SCREEN_SHARING',
  REFUSE_SCREEN_SHARING = 'REFUSE_SCREEN_SHARING',
  CANCEL_SCREEN_SHARING = 'CANCEL_SCREEN_SHARING',
  ACCEPTED_SCREEN_SHARING = 'ACCEPTED_SCREEN_SHARING',
  END_SCREEN_SHARING = 'END_SCREEN_SHARING',
  FAILURE_SCREEN_SHARING = 'FAILURE_SCREEN_SHARING',
  AUTOMATIC = 'AUTOMATIC',
  SURVEY = 'SURVEY',
  SCRIPT_REDIRECTION = 'SCRIPT_REDIRECTION',
  END = 'END',
  CHAT_AUTOMATIC_MESSAGE = 'CHAT_AUTOMATIC_MESSAGE',
}
